import React, { FC, ReactNode } from 'react';

interface Props {
    label: string;
    children: ReactNode;
}

const FormItem: FC<Props> = ({ label, children }) => {
    return (
        <div className="flex flex-col gap-[8px]">
            <div className="text-sf-gray-800 text-13 font-sf font-medium">{label}</div>
            {children}
        </div>
    );
};

export default FormItem;
